import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';
import { RoleEnum } from '@app/infrastructure/models/role';
import {
  StudentClassListItemDTO,
  IStudentClassListItemDTO,
} from '@models/student-classroom';
import { ROUTES } from '@app/infrastructure/utils/constants';

@Component({
  selector: 'app-shared-classroom-card-smart',
  template: `
    <app-shared-classroom-card-presentation
      [classListItem]="classListItem"
      [route]="route"
      [canNavigate]="canNavigate"
    >
    </app-shared-classroom-card-presentation>
  `,
})
export class ClassroomCardSmartComponent implements OnInit {
  @Input() public classListItem: IStudentClassListItemDTO =
    new StudentClassListItemDTO();
  canNavigate: boolean = true;
  get route(): string {
    return `classrooms/${this.classListItem.id}`;
  }
  constructor(
    private userStateService: UserStateService,
    private router: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.userStateService.getUserSession().subscribe((user) => {
      if (
        user?.role?.roleName === RoleEnum.STUDENT &&
        this.router.snapshot.data.title === ROUTES.student.classroomList.title
      ) {
        this.canNavigate = false;
      }
    });
  }
}
